'use strict';

/*global app*/
/*global services*/
/*global blockElement*/
/*global unBlockElement*/
/*global wrrSuccess*/

function BarcodePairing(containerId, params) {
  this.containerId = containerId;
  this.$container = null;
  this.$form = null;
  this.params = params;

  this.init();
}

BarcodePairing.prototype = $.extend({}, {
  constructor: 'BarcodePairing',

  registerCallbacks: function registerCallbacks() {
    var _this = this;

    _this.$container.on('click', '.barcode-pairing__article', function () {
      _this.selectArticle($(this));
      return false;
    });

    _this.$container.on('click', '.barcode-pairing__reasons', function () {
      _this.selectReason($(this));
      return false;
    });

    return _this;
  },

  //----------------------------------------------------------------------------

  selectArticle: function selectArticle($article) {
    var _this = this;

    var $selected = _this.$container.find('.barcode-pairing__article.well--selected');
    $selected.find('[name$="[Selected]"]').removeAttr('checked');
    $selected.removeClass('well--selected');

    $article.find('[name$="[Selected]"]').attr('checked', true);
    $article.addClass('well--selected');

    _this.$form.find('input:text:visible').focus();

    return _this;
  },

  selectReason: function selectReason() {
    var _this = this;

    services.get('select-service').selectValue({ list: _this.params.reasons }, function (value) {
      if (value === null) {
        return;
      }

      _this.$form.find('[name$="[ReasonId]"]').val(value);

      var data = {
        LocationId: _this.$form.find('[name$="[LocationId]"]').val(),
        ArticleId: _this.$form.find('.well--selected').find('[name$="[Id]"]').val(),
        ReasonId: value,
        Barcode: _this.$form.find('[name$="[Barcode]"]').val(),
      };

      blockElement(_this.$container);
      app.getFormation('article:save_barcode_reason', data, function (res) {
        unBlockElement(_this.$container);
        if (res.msg === 'SUCCESS' && res.data.Result === wrrSuccess) {
          window.location = _this.$container.find('.barcode-pairing__back').attr('href');
        } else {
          app.viewErrorMessage(res.error);
        }
      });
    });

    return _this;
  },

  //----------------------------------------------------------------------------

  init: function init() {
    var _this = this;

    _this.$container = $('#' + _this.containerId);
    _this.$form = _this.$container.find('form');

    _this.registerCallbacks();

    return _this;
  }
});
